import axios from "axios";
import { Toast } from "../../util/Toast";
import {
    GET_ADMIN_ACCESS_BY_ADMIN_ID,
    CREATE_ADMIN_ACCESS,
    UPDATE_ADMIN_ACCESS,
    UPDATE_ADMIN_ROLE,
    UPDATE_FEATURE_ACCESS,
    CLOSE_ADMIN_ACCESS_DIALOG,
} from "./types";

// Get admin access by adminId
export const getAdminAccessByAdminId = (adminId) => (dispatch) => {
    axios
        .get(`adminAccess/admin/${adminId}`)
        .then((res) => {
            console.log("Admin Access Data: ", res.data);
            if (res.data.status) {
                dispatch({ type: GET_ADMIN_ACCESS_BY_ADMIN_ID, payload: res.data.adminAccess });
            } else {
                // No access record found, set null to indicate we need to create one
                dispatch({ type: GET_ADMIN_ACCESS_BY_ADMIN_ID, payload: null });
            }
        })
        .catch((error) => {
            Toast("error", error.message);
            dispatch({ type: GET_ADMIN_ACCESS_BY_ADMIN_ID, payload: null });
        });
};

// Create admin access
export const createAdminAccess = (data) => (dispatch) => {
    axios
        .post(`adminAccess`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Admin access created successfully!");
                dispatch({ type: CREATE_ADMIN_ACCESS, payload: res.data.adminAccess });
                dispatch({ type: CLOSE_ADMIN_ACCESS_DIALOG });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

// Update admin access by adminId
export const updateAdminAccessByAdminId = (adminId, data) => (dispatch) => {
    axios
        .put(`adminAccess/admin/${adminId}`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Admin access updated successfully!");
                dispatch({ type: UPDATE_ADMIN_ACCESS, payload: res.data.adminAccess });
                dispatch({ type: CLOSE_ADMIN_ACCESS_DIALOG });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

// Update admin role
export const updateAdminRole = (accessId, role) => (dispatch) => {
    axios
        .patch(`adminAccess/role/${accessId}`, { role })
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Role updated successfully!");
                dispatch({ type: UPDATE_ADMIN_ROLE, payload: res.data.adminAccess });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

// Update feature access
export const updateFeatureAccess = (accessId, featurePath, accessLevel) => (dispatch) => {
    axios
        .patch(`adminAccess/feature/${accessId}`, { featurePath, accessLevel })
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: UPDATE_FEATURE_ACCESS, payload: res.data.adminAccess });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
